import React from 'react'
import { Icon } from 'semantic-ui-react'

export const HidePanel = () => {
  return <React.Fragment>
    <div style={{ textAlign: 'center' }}>

    </div>
  </React.Fragment>
}